import { render, staticRenderFns } from "./LawClientAccountingLedesList.vue?vue&type=template&id=7818a2de&"
import script from "./LawClientAccountingLedesList.vue?vue&type=script&lang=js&"
export * from "./LawClientAccountingLedesList.vue?vue&type=script&lang=js&"
import style0 from "./LawClientAccountingLedesList.vue?vue&type=style&index=0&id=7818a2de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports